(function () {
  const instances = new Map();
  const MOBILE_BREAKPOINT = 768;
  let resizeTimer = null;

  function destroySwiper(sectionId) {
    const existing = instances.get(sectionId);

    if (existing) {
      try {
        existing.destroy(true, true);
      } catch (e) {
        console.warn("Errore distruzione swiper:", e);
      }

      instances.delete(sectionId);
    }
  }

  function updateNavToolsVisibility(swiper, navTools) {
    if (!navTools) return;
    navTools.style.display = swiper.isLocked ? "none" : "";
  }

  function initDesktopSwiper(section) {
    const carousel = section.querySelector(".js-swiper-product-carousel");
    const scrollBar = section.querySelector(".js-product-carousel-swiper-scrollbar");
    const navTools = section.querySelector(".product-carousel_nav-tools");
    const prev = section.querySelector(".js-product-carousel-arrow-prev");
    const next = section.querySelector(".js-product-carousel-arrow-next");
    const sectionId = section.id;

    if (!carousel || instances.has(sectionId)) return;

    const swiperConfig = {
      slidesPerView: 1.2,
      spaceBetween: 20,
      slidesOffsetAfter: 20,
      scrollbar: scrollBar
        ? {
            el: scrollBar,
            draggable: true
          }
        : false,
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
          slidesOffsetAfter: 0
        },
        990: {
          slidesPerView: 3,
          spaceBetween: 24,
          slidesOffsetAfter: 0
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 24,
          slidesOffsetAfter: 0
        }
      },
      on: {
        init: function () {
          updateNavToolsVisibility(this, navTools);
        },
        resize: function () {
          updateNavToolsVisibility(this, navTools);
        },
        update: function () {
          updateNavToolsVisibility(this, navTools);
        }
      }
    };

    if (prev && next) {
      swiperConfig.navigation = {
        prevEl: prev,
        nextEl: next
      };
    }

    const swiper = new Swiper(carousel, swiperConfig);
    instances.set(sectionId, swiper);
  }

  function handleResize() {
    const isMobile = window.innerWidth < MOBILE_BREAKPOINT;

    document.querySelectorAll(".js-get-section").forEach((section) => {
      const sectionId = section.id;
      const hasSwiper = instances.has(sectionId);
      const isMobileClass = section.classList.contains("product-carousel--stack-mobile");

      if (isMobile) {
        if (!isMobileClass) {
          section.classList.add("product-carousel--stack-mobile");
        }

        if (hasSwiper) {
          destroySwiper(sectionId);
        }
      } else {
        if (isMobileClass) {
          section.classList.remove("product-carousel--stack-mobile");
        }

        if (!hasSwiper) {
          initDesktopSwiper(section);
        }
      }
    });
  }

  function init() {
    handleResize();

    window.addEventListener("resize", function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(handleResize, 250);
    });

    document.addEventListener("shopify:section:load", function () {
      handleResize();
    });

    document.addEventListener("shopify:section:unload", function (e) {
      if (e.detail.section) {
        destroySwiper(e.detail.section.id);
      }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
